import React from "react";
import { Link } from "gatsby";

const reasons = [
  {
    number: "01",
    title: "We Start With Business Outcomes",
    text: "We connect Microsoft cloud decisions to productivity, collaboration, security, governance, cost control, compliance readiness, and long-term growth.",
  },

  {
    number: "02",
    title: "We Build and Improve Microsoft Workplaces",
    text: "Microsoft 365, SharePoint, Teams, OneDrive, workflows, identity, and security controls are shaped around how the organisation actually works.",
  },

  {
    number: "03",
    title: "We Prioritise the Right Roadmap",
    text: "You get a clear order of action across licensing, collaboration, automation, access, security, governance, and support rather than a disconnected list of IT tasks.",
  },

  {
    number: "04",
    title: "We Stay as an Ongoing Advisor",
    text: "CloudLogic can help implement the roadmap, support users, improve cloud administration, strengthen governance, and guide continuous improvement.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="cl-why-section">
      <div className="container">

        {/* ================= Section Header ================= */}

        <div className="cl-why-header">

          <span className="cl-why-badge">
            Why Buyers Choose CloudLogic
          </span>

          <h2>
            Microsoft Cloud Guidance That Helps Leaders Modernise With Confidence
          </h2>

          <p>
            CloudLogic brings Microsoft implementation, digital workplace,
            security, governance, compliance readiness, and managed support
            together so technology becomes easier to run and easier to trust.
          </p>

        </div>

        {/* ================= Cards ================= */}

        <div className="cl-why-grid">

          {reasons.map((item, index) => (
            <div className="cl-why-card" key={index}>

              <div className="cl-why-card-top">

                <span className="cl-why-number">
                  {item.number}
                </span>

                <div className="cl-why-divider"></div>

              </div>

              <h3>{item.title}</h3>

              <p>{item.text}</p>

            </div>
          ))}

        </div>

        {/* ================= Bottom CTA ================= */}

        <div className="cl-why-bottom">

          <div className="cl-why-tags">
            <span>Microsoft 365 & Azure Governance</span>
            <span>Digital Workplace & Automation</span>
            <span>Security & Compliance Readiness</span>
          </div>

          <div className="cl-why-buttons">

            <Link to="/contact" className="default-btn">
              Book Health Check
            </Link>

            <Link to="/services" className="cl-why-secondary-btn">
              Explore Services
            </Link>

          </div>

        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
